import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';
import {
  getResult,
  mapState,
  createCancelToken,
} from '@deerplusofficial/pos-helper';
import actions from '../../actions';

const { update: updateChannel } = actions.channel;

export default () => Component =>
  fp.compose(
    withRouter(),
    withClient(),
    connect(
      mapState(['channel']),
      { updateChannel }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryChannel');

      static propTypes = {
        channelId: PropTypes.string,
      };

      static defaultProps = {
        channelId: '',
      };

      async componentDidMount() {
        const {
          channelId,
          updateChannel,
          channel,
          client: { onError, POSApi },
        } = this.props;

        if (channel.id === channelId) return;

        try {
          const { channel: profile } = getResult(
            await POSApi.get(`/channels/${channelId}`, {
              cancelToken: createCancelToken(this.cancelFetch),
            })
          );

          updateChannel(profile);
        } catch (e) {
          onError(e);
        }
      }

      componentWillUnmount() {
        !_.isUndefined(this.cancelFetch) && this.cancelFetch();
      }

      render() {
        return <Component {...this.props} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryChannel.js